import {FC} from 'react'
import LineItem from './LineItem'

type Props = {
  items: any[]
}

const FulfilledItemList: FC<Props> = ({items}) => {
  return (
    <div className='flex-grow-1'>
      <div className='table-responsive border-bottom mb-9'>
        <table className='table mb-3'>
          <thead className='bg-transparent border-0'>
            <tr className='border-bottom fs-6 fw-bolder text-muted'>
              <th className='min-w-175px pb-2'>Items</th>
              <th className='min-w-70px text-end pb-2'></th>
              <th className='min-w-80px text-end pb-2'></th>
              <th className='min-w-100px text-end pb-2'>QTY</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => {
              return <LineItem key={index} item={item} />
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default FulfilledItemList
